import {
  default as AntSelect,
  SelectProps as AntSelectProps,
} from "antd/lib/select";
import { pipe, ReadonlyArray } from "fp";

import React from "react";
import styled from "styled-components";

export function Select<Option extends Select.Option>({
  options,
  selectedKeys,
  optionToKey,
  optionToValue,
  Option,
  ...props
}: Select.Props<Option>) {
  const selection = selectedKeys
    ? pipe(
        options,
        ReadonlyArray.filter((option) =>
          selectedKeys.includes(optionToKey(option))
        ),
        ReadonlyArray.map(optionToValue),
        // eslint-disable-next-line functional/prefer-readonly-type
        (ary) => ary as string[]
      )
    : undefined;

  return pipe(
    options,
    ReadonlyArray.map((option) => (
      <Select.Option key={optionToKey(option)} value={optionToValue(option)}>
        <Option {...option} />
      </Select.Option>
    )),
    (children) => (
      <Select.Container>
        <AntSelect value={selection} {...props}>
          {children}
        </AntSelect>
      </Select.Container>
    )
  );
}

export namespace Select {
  export type Props<Option extends Select.Option> = Omit<
    // eslint-disable-next-line functional/prefer-readonly-type
    AntSelectProps<string[]>,
    "options"
  > & {
    readonly options: readonly Option[];
    readonly selectedKeys?: readonly string[];
    readonly optionToKey: (option: Option) => string;
    readonly optionToValue: (option: Option) => string;
    readonly Option: React.Fn<Option>;
  };

  export type Option = Record<string, unknown>;
  export const Option = AntSelect.Option;

  export const Container = styled.div`
    & > .ant-select {
      width: 250px;
    }
  `;
}
